<template>
    <div class="cashback-content">
        <div class="cashback-head">
            <div class="cashback-head-text">
                <div class="cashback-price">¥{{ sumCashback }}</div>
                <div class="cashback-price-sub">总收益金额</div>
            </div>
            <div class="cashRecord-btn" @click="toCashRecord()">提现记录</div>
        </div>
        <div class="cashback-count">
            <div class="cashback-num">账户余额：¥ {{ balance }}</div>
            <div class="cashback-cash-btn" v-if="balance > 0" @click="toApplyCashback()">提现</div>
        </div>
        <div class="cashback-date">
            <div class="cashback-date-content">
                <div class="cashback-date-title">时间检索</div>
                <div class="cashback-date-each" @click="openCalendar"> {{ startTime ? formattedDateTimeByDate(startTime)
                    : '选择日期' }}</div>
                <div class="cashback-date-line"></div>
                <div class="cashback-date-each" @click="openCalendar">{{ endTime ? formattedDateTimeByDate(endTime) :
                    '选择日期' }}</div>
            </div>
            <van-calendar v-model:show="dateShow" type="range" @close="clearDate" switch-mode="year-month"
                @confirm="onConfirm" />
        </div>
        <div class="order-content-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled"
            infinite-scroll-distance="20" infinite-scroll-immediate="false">
            <div class="order-content-each" v-for="(item, value) in rows" :key="value">
                <div class="order-id-all">
                    <div class="order-id">支付时间：{{ item.payTime ? formattedDateTime(item) : '' }}</div>
                    <div class="order-status">{{ item.phone }}</div>
                </div>
                <div class="order-info">
                    <template v-if="item.image != null && item.image != ''">
                        <img :src=item.image class="order-img" />
                    </template>
                    <template v-else>
                        <img src="../assets/image/teaching-img.png" class="order-img" />
                    </template>
                    <div class="order-text">
                        <div class="order-name">{{ item.name }}</div>
                        <div class="order-price">交易金额：¥ {{ item.orderPrice }}</div>
                        <div class="order-price-cash">分销收益：¥ {{ item.cashback }}</div>
                    </div>
                </div>
            </div>
            <!-- 下拉加载时候加loading旋转动效 -->
            <div v-if="loading" style="margin-top:10px;" class="loading">
                <span>loding...</span>
            </div>
        </div>
    </div>
</template>
<script>
import { listCashbackOrder } from '@/api/common'
export default {
    name: 'CashbackPage',
    props: ['id'],
    data() {
        return {
            merchantId: '',
            rows: [],
            pageNum: 1,
            pageSize: 5,
            loading: false,
            pageIndex: 1,
            pages: '',
            sumCashback: 0,
            dateShow: false,
            startTime: '',
            endTime: '',
            balance: 0
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.getCashbackOrderList();
    },
    //计算
    computed: {
        noMore() {
            //当起始页数大于总页数时停止加载
            return this.pageIndex >= this.pages;
        },
        disabled() {
            return this.loading || this.noMore;
        },
    },
    methods: {
        getCashbackOrderList() {
            let params = {
                'pageSize': this.pageSize,
                'pageNum': this.pageNum,
                'orderByColumn': 'tgo.pay_time desc,tgo.id',
                'isAsc': 'desc'
            };
            if (this.startTime && this.startTime != null) {
                params.startTime = new Date(this.startTime)
            }
            if (this.endTime && this.endTime != null) {
                let currentDate = new Date(this.endTime); // 当前日期
                currentDate.setDate(currentDate.getDate() + 1); // 加一天
                params.endTime = currentDate;
            }
            listCashbackOrder(params).then((res) => {
                if (res.code === 200) {
                    this.rows = this.rows.concat(res.rows);
                    this.pages = Math.ceil(res.total / this.pageSize);
                    this.sumCashback = res.sumCashback || 0;
                    this.balance = res.balance || 0;
                }
            })
        },
        load() {
            //滑到底部时进行加载
            this.loading = true;
            let params = {
                'pageSize': this.pageSize,
                'pageNum': this.pageIndex + 1,
                'orderByColumn': 'tgo.pay_time desc,tgo.id',
                'isAsc': 'desc'
            };
            if (this.startTime && this.startTime != null) {
                params.startTime = new Date(this.startTime)
            }
            if (this.endTime && this.endTime != null) {
                let currentDate = new Date(this.endTime); // 当前日期
                currentDate.setDate(currentDate.getDate() + 1); // 加一天
                params.endTime = currentDate;
            }
            listCashbackOrder(params).then((res) => {
                this.rows = this.rows.concat(res.rows);
                this.pageIndex++
                this.loading = false;
            })
        },
        formattedDateTime(item) {
            return this.$formatDateTime(new Date(item.payTime), 'YYYY-MM-DD HH:mm');
        },
        formattedDateTimeByDate(item) {
            return this.$formatDateTime(new Date(item), 'YYYY-MM-DD');
        },
        onConfirm(value) {
            this.dateShow = false;
            this.startTime = value[0].getTime();
            this.endTime = value[1].getTime();
            this.resetOrderList();
        },
        clearDate() {
            if (this.startTime === '' && this.endTime === '') {
                this.resetOrderList();
            }
        },
        resetOrderList() {
            this.rows = [];
            this.pageIndex = 1;
            this.pages = '';
            this.loading = false;
            this.getCashbackOrderList();
        },
        openCalendar() {
            this.dateShow = true;
            this.startTime = '';
            this.endTime = '';
        },
        toApplyCashback() {
            this.$router.push({ name: 'applyCashback', params: { id: this.merchantId } });
        },
        toCashRecord() {
            this.$router.push({ name: 'cashbackRecord', params: { id: this.merchantId } });
        }
    }
}
</script>
<style scoped>
.cashback-content {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    overflow: hidden;
}

.cashback-head {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 130px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../assets/image/cashback-background.png');
}

.cashRecord-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 14px;
    color: #fff;
}

.cashback-head-text {
    overflow: hidden;
}

.cashback-price {
    font-family: PingFangSC-Medium;
    font-size: 34px;
    color: #FFFFFF;
    letter-spacing: 3px;
    text-align: center;
    line-height: 48px;
    font-weight: 500;
}

.cashback-price-sub {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
}

.order-content-list {
    flex: 1;
    overflow-y: auto;
}

.order-content-each {
    padding: 15px 15px 18px 15px;
    margin-top: 5px;
    background-color: #fff;
}

.order-id-all {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 500;
}

/* 加载时候转圈的动效 */
.loading {
    text-align: center;
}

.loading span {
    display: inline-block;
    font-size: 14px;
    color: #666;
}

.order-info {
    display: flex;
    margin-top: 10px;
}

.order-img {
    margin-right: 10px;
    width: 142px;
    height: 90px;
    object-fit: cover;
    border-radius: 5px;
}

.order-text {
    flex: 1;
}

.order-name {
    font-family: PingFangHK-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    font-weight: 400;
    text-align: left;
}

.order-price {
    margin-top: 5px;
    text-align: left;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 500;
}

.order-price-cash {
    margin-top: 5px;
    text-align: left;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #F11515;
    letter-spacing: 0;
    font-weight: 500;
}

.cashback-date {
    padding: 15px;
    overflow: hidden;
}

.cashback-date-content {
    display: flex;
    align-items: center;
}

.cashback-date-title {
    margin-right: 11px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999999;
    font-weight: 400;
}

.cashback-date-line {
    margin: 0 11px;
    width: 14px;
    height: 1px;
    background-color: #979797;
}

.cashback-date-each {
    flex: 1;
    line-height: 36px;
    height: 36px;
    text-align: center;
    background: #F2F2F2;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
}

.cashback-count {
    min-height: 55px;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
}

.cashback-num {
    font-size: 14px;
    color: #333333;
}

.cashback-cash-btn {
    width: 68px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
    background: #0095D9;
    border-radius: 15.5px;
}
</style>